/**
 * Normalize and validate a website URL.
 * Accepts formats like "example.com", "www.example.com", "https://example.com"
 * Returns normalized URL with https:// prefix, or null if invalid.
 */
export function normalizeWebsiteUrl(input: string): string | null {
  const trimmed = input.trim()
  if (!trimmed) return null

  let url = trimmed
  if (!/^https?:\/\//i.test(url)) {
    url = 'https://' + url
  }

  try {
    const parsed = new URL(url)

    if (!['http:', 'https:'].includes(parsed.protocol)) {
      return null
    }

    if (!parsed.hostname.includes('.')) {
      return null
    }

    if (parsed.hostname.startsWith('.') || parsed.hostname.endsWith('.')) {
      return null
    }

    const parts = parsed.hostname.split('.')
    const tld = parts[parts.length - 1]
    if (tld.length < 2) {
      return null
    }

    return parsed.href
  } catch {
    return null
  }
}

/**
 * Check if website input is valid (required field).
 */
export function isValidWebsiteInput(input: string): boolean {
  if (!input.trim()) return false
  return normalizeWebsiteUrl(input) !== null
}
